import * as React from 'react';
import noop from 'lodash/fp/noop';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { selectionByValue } from '~/features/base/utils/selectUtils';
import { createDownloadPrioritiesOptions, NORMAL } from '~/features/base/constants/downloadPriorities';
import Select from '@rio-cloud/rio-uikit/Select';

export const DownloadPrioritySelectFormItem = ({
    value,
    onChange,
}) => {
    const releaseStatePreset = value || NORMAL;
    const optionsWithSelection = selectionByValue(releaseStatePreset)(createDownloadPrioritiesOptions());
    return (
        <div className='form-group form-group-release-state'>
            <label className='control-label'>
                <FormattedMessage id='intl-msg:priority'/>
            </label>
            <div>
                <Select options={optionsWithSelection} onChange={onChange}/>
            </div>
        </div>
    );
};

DownloadPrioritySelectFormItem.defaultProps = {
    // props
    value: NORMAL,
    // functions
    onChange: noop,
};

DownloadPrioritySelectFormItem.propTypes = {
    // props
    value: PropTypes.string,
    // functions
    onChange: PropTypes.func,
};
